import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Check } from 'react-feather';
import BookProposal from '../Modals/BookProposal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FileUploadDisplay from '../../components/FileUploadDisplay';

const UploadBook = ({ onFileSelect, initialFile }) => {
    const [currentFile, setCurrentFile] = useState(null);
    const [showBookProposal, setShowBookProposal] = useState(false);

    // Load initial file when component mounts or initialFile changes
    useEffect(() => {
        if (initialFile) {
            // If initialFile is a File object, use it directly
            if (initialFile instanceof File) {
                setCurrentFile(initialFile);
            }
            // If initialFile is a string (S3 URL), set it as current file
            else if (typeof initialFile === 'string') {
                setCurrentFile(initialFile);
            }
            // If initialFile is an object with file data
            else if (initialFile && typeof initialFile === 'object') {
                if (initialFile.url) {
                    setCurrentFile(initialFile.url);
                } else if (initialFile.data) {
                    const file = new File(
                        [initialFile.data],
                        initialFile.name || 'book_proposal.pdf',
                        { type: 'application/pdf' }
                    );
                    setCurrentFile(file);
                }
            }
        } else {
            setCurrentFile(null);
        }
    }, [initialFile]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject
    } = useDropzone({
        accept: { 'application/pdf': [] },
        maxFiles: 1,
        maxSize: 5 * 1024 * 1024, // 5MB limit
        onDrop: (acceptedFiles, rejectedFiles) => {
            if (acceptedFiles.length > 0) {
                const newFile = acceptedFiles[0];
                setCurrentFile(newFile);
                onFileSelect(newFile);
                toast.success('File selected successfully');
            }

            // Handle rejected files
            if (rejectedFiles.length > 0) {
                const rejectedFile = rejectedFiles[0];
                if (rejectedFile.errors.some(error => error.code === 'file-too-large')) {
                    toast.error('File size must be less than 5MB');
                } else if (rejectedFile.errors.some(error => error.code === 'file-invalid-type')) {
                    toast.error('Only PDF files less than 5MB are allowed');
                } else {
                    toast.error('File upload failed. Please try again.');
                }
            }
        }
    });

    const handleRemoveFile = () => {
        setCurrentFile(null);
        onFileSelect(null);
        toast.info('File removed. You can upload a new file.');
    };

    return (
        <>
            <div className="dropzone">
                <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
                    <input {...getInputProps()} />
                    <div className="dropzone-inner-wrapper">
                        {isDragAccept && (
                            <div>
                                <div className="d-100 btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white">
                                    <Check className="d-50" />
                                </div>
                                <div className="font-size-sm text-success">
                                    PDF file accepted!
                                </div>
                            </div>
                        )}
                        {isDragReject && (
                            <div>
                                <div className="font-size-sm text-danger">
                                    Only PDF files les than 5MB are allowed!
                                </div>
                            </div>
                        )}
                        {!isDragActive && (
                            <div className="upload_detail upload_detail2 text-center">
                                <img src="/assets/images/upload.svg" alt="Upload" />
                                <h4>Upload Book Proposal</h4>
                                <h5 className='wid_text'>Please upload a PDF document of maximum 5 MB size, outlining the detailed structure of the proposal in a minimum of 2,000 to a maximum of 3,000 words</h5>
                                <h6 onClick={e => {
                                        e.stopPropagation();
                                        setShowBookProposal(true);
                                    }}>
                                    <i className="bi bi-info-circle"></i> Document Templates
                                </h6>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {showBookProposal && <BookProposal onClick={() => setShowBookProposal(false)} />}
            
            {/* Display uploaded file with actions */}
            {currentFile && (
                <FileUploadDisplay
                    file={currentFile}
                    onRemove={handleRemoveFile}
                    showDownload={true}
                    showView={true}
                    showRemove={true}
                />
            )}
        </>
    );
};

export default UploadBook;
